import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { Seo } from "../components/Seo";

export default function Login() {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();
  const loc = useLocation();

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    const r = await login(email, password);
    setLoading(false);
    if (r.ok) nav(loc.state?.from || "/feed");
    else setErr(r.error);
  };

  return (
    <div data-testid="login-page" className="min-h-screen flex items-center justify-center px-6 pt-24 pb-12">
      <Seo title="Log in" description="Log in to your Dr. Cuts members studio." path="/login" />
      <div className="w-full max-w-md">
        <div className="overline">Members entrance</div>
        <h1 className="font-display text-5xl mt-3">Welcome back.</h1>
        <p className="text-white/60 mt-2">Step back into the studio.</p>

        <form onSubmit={submit} className="mt-10 space-y-4">
          <div>
            <label className="overline block mb-2" style={{color:"#A0B0A8"}}>Email</label>
            <input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="input-dark" placeholder="you@golf.com" />
          </div>
          <div>
            <label className="overline block mb-2" style={{color:"#A0B0A8"}}>Password</label>
            <input data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="input-dark" placeholder="••••••••" />
          </div>
          {err && <div data-testid="login-error" className="text-sm text-red-400">{err}</div>}
          <button data-testid="login-submit" disabled={loading} className="btn-primary w-full">{loading ? "Logging in..." : "Log in"}</button>
        </form>

        <div className="mt-8 text-sm text-white/60">
          No locker yet? <Link to="/register" className="text-[#C9A227] underline-offset-4 hover:underline" data-testid="login-to-register">Create one</Link>
        </div>
      </div>
    </div>
  );
}
